import ActionButtons from '@/components/common/ActionButtons';
import Table from '@/components/common/table/Table';
import { useAccountForm } from '@/context/accountFormContext/AccountFormContextProvider';
import React, { useCallback, useEffect } from 'react';
import { FaFilePdf, FaTrash } from 'react-icons/fa';
import { MdEdit } from 'react-icons/md';
import AccountForm from './AccountForm';
import { useModal } from '@/components/common/modal/ModalContext';

const AccountFormTable = () => {
  const {
    getAccountFormAPI,
    clearFormData,
    accountFormData,
    setAccountFormData,
    deleteAccountFormAPI,
    totalElements,
    currentPage,
    setCurrentPage,
    pageSize,
    getAccountFormPdfAPI,
    sortBy,
    setSortBy,
    sortDir,
    setSortDir,
    searchQuery,
  } = useAccountForm();
  const { openModal, closeModal } = useModal();

  useEffect(() => {
    getAccountFormAPI();
    return () => {
      setAccountFormData([]);
    };
  }, [currentPage]);

  const handleOpenModal = useCallback(
    (user) => {
      clearFormData();
      openModal(
        <AccountForm closeModal={closeModal} formData={user} />,
        'Update Debtor Account Form',
      );
    },
    [
      // clearFormData,
      openModal,
      closeModal,
    ],
  );

  const renderActionButtons = (user) => (
    <ActionButtons
      actions={[
        {
          icon: <FaTrash />,
          onClick: () => deleteAccountFormAPI(user.id),
          tooltip: 'Delete Product',
          className: 'text-red-500 pr-6',
        },
        {
          icon: <MdEdit />,
          onClick: () => handleOpenModal(user),
          tooltip: 'Edit Product',
          className: 'text-gray-500 pr-6',
        },
        {
          icon: <FaFilePdf />,
          onClick: () => getAccountFormPdfAPI(user.id),
          tooltip: 'Download PDF',
          className: 'text-red-500',
        },
      ]}
    />
  );

  const handleSortChange = ({ field, direction }) => {
    setSortBy(field); // Update the sortBy field
    setSortDir(direction); // Update the sort direction
    getAccountFormAPI(currentPage, pageSize, searchQuery, field, direction); // Fetch sorted data
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const columns = [
    {
      header: 'Company ABN',
      field: 'companyABN',
    },
    {
      header: 'Company',
      field: 'company',
    },
    {
      header: 'Business Code',
      field: 'businessCode',
    },
    {
      header: 'Email Address',
      field: 'emailAddress',
    },
    {
      header: 'Phone Number',
      field: 'phoneNumber',
    },
    {
      header: 'Pronto Account Code',
      field: 'prontoAccountCode',
    },
    {
      header: 'Created Date',
      render: (row) => formatDate(row.createdDate),
      field: 'createdDate',
    },
    {
      header: 'Action',
      render: renderActionButtons,
    },
  ];
  return (
    <Table
      data={accountFormData}
      columns={columns}
      totalElements={totalElements}
      pageSize={pageSize}
      currentPage={currentPage}
      onPageChange={(newPage) => setCurrentPage(newPage)}
      onSortChange={handleSortChange} // Pass sorting handler
      sortConfig={{ field: sortBy, direction: sortDir }} // Pass current sorting state
    />
  );
};

export default AccountFormTable;
